import { SYNC_KEY_COSTOS_ASPERSION } from "../../../constantes";
import { CostosPlataformaService, TarifaAspersionItem } from "../../generated/grpc/plataforma_costos_pb";
import { CostoAspersionResponse } from "../../response/costos/CostoAspersionResponse";
import { ServiceGetListBase } from "../base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Categorías de PROTEC con sus cultivos (`CostosPlataformaService`, gRPC). Pipeline las reusa para cotizar. */
export class CostoAspersionListService extends ServiceGetListBase<CostoAspersionResponse> {
  static readonly instance = new CostoAspersionListService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_COSTOS_ASPERSION;

  /** gRPC-Web (`ListAspersion`): no eliminadas, por orden, con cultivos activos. */
  protected async fetchItems(): Promise<CostoAspersionResponse[]> {
    const r = await grpcCall(() => grpcClient(CostosPlataformaService).listAspersion({}));
    return r.items.map(toCostoAspersionResponse);
  }
}

/** Mensaje gRPC de la categoría → respuesta. */
export function toCostoAspersionResponse(t: TarifaAspersionItem): CostoAspersionResponse {
  return {
    id: t.id,
    isEliminado: false,
    categoria: t.categoria,
    precioPorHa: Number(t.precioPorHa),
    orden: t.orden,
    cultivos: t.cultivos.map((c) => ({ cultivoId: c.cultivoId, nombre: c.nombre })),
  };
}
